import { defineComponent as _defineComponent } from 'vue'
import MessageList from './MessageList.vue';
import ChatEditor from './ChatEditor.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {


return { __sfc: true,MessageList, ChatEditor }
}

})